import { Pagination } from '@arco-design/web-react';

import styles from '../index.module.less';
import type { ImageListState } from '../types';

interface ImageListPaginationProps {
  listState: ImageListState;
  /** inline：列表下方；formExtra：表单项 extra 内，与校验信息同一行布局 */
  variant: 'inline' | 'formExtra';
}

/** 镜像列表分页，表单与非表单共用配置 */
export function ImageListPagination({ listState, variant }: ImageListPaginationProps) {
  const { page, limit, total, onPageChange } = listState;
  if (total <= limit) {
    return null;
  }

  const wrapClass = variant === 'inline' ? styles.paginationBar : styles.paginationBarInFormExtra;

  return (
    <div className={wrapClass}>
      <Pagination total={total} current={page} pageSize={limit} showTotal={true} onChange={onPageChange} />
    </div>
  );
}
